import AuthenticatedResource  from 'resources/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class UserResource extends AuthenticatedResource {
  static urlRoot = '/admin/users'

  readonly id: number | undefined = undefined;
  readonly name: string = '';
  readonly wallet_address: string = '';
  readonly courses: Record<string, unknown>[] = [];
  readonly rewards: Record<string, unknown>[] = [];

  pk() {
    return this.id?.toString();
  }
}